export const assetSectionsData = [
  {
    id: "kbAddOneFramework",
    title: "KB Add One Framework",
    subtitle: "Asset",
    description:
      "KB데이타시스템의 집약된 IT 기술로 구현된 오픈소스 기반 통합 개발 플랫폼입니다.",
    bannerImage: "/asset/section-banner-1.png",
    bannerImageMobile: "/asset/section-banner-1-m.png",
    features: [
      {
        icon: "/asset/icon-1-1-1.png",
        title: "검증된 안정성",
        description:
          "KB금융 계열사의 보안 기준을 충족했으며 통합단말, 시스템, 배치 등 다양한 채널과 안정적으로 연계할 수 있습니다.",
      },
      {
        icon: "/asset/icon-1-1-2.png",
        title: "고성능",
        description:
          "대량의 메타데이터 캐싱과 오픈소스 기반 경량화, 비동기·병렬 처리 기술을 통해 대규모 트래픽에서도 빠르고 안정적인 서비스를 제공합니다.",
      },
      {
        icon: "/asset/icon-1-1-3.png",
        title: "유연한 장애 대응",
        description:
          "경량화된 구조와 유연한 설계로 빠른 개발·배포와 재기동을 지원하고, 실시간 반영과 Timeout 으로 안정적이고 유연한 운영 환경을 제공합니다.",
      },
      {
        icon: "/asset/icon-1-1-4.png",
        title: "모니터링",
        description:
          "흩어진 로그를 통합 관리 및 시각화하고 Spring Admin 기반 대시보드에서 서비스 상태를 실시간으로 파악할 수 있습니다.",
      },
      {
        icon: "/asset/icon-1-1-5.png",
        title: "개발 편의성",
        description:
          "환경에 최적화된 연계 어댑터와 공통 모듈을 제공하여 개발 효율성을 높이고, 코드 자동 생성 기능으로 전환 프로젝트까지 유연하게 지원합니다.",
      },
      {
        icon: "/asset/icon-1-1-6.png",
        title: "채널 확장성",
        description:
          "RESTful 서비스와 함께 다양한 프로토콜과 메시지 형식을 지원하여 내부 업무와 백엔드 서비스를 포함한 다양한 채널로 유연하게 확장됩니다.",
      },
    ],
    functions: [
      {
        icon: "/asset/icon-1-2-1.png",
        title: "프레임워크 운영 환경",
        description:
          "컨테이너·CI/CD·API 기반으로 클라우드 네이티브 아키텍처를 지원하며 VM(WAS) 환경과 모놀리식 구조에서도 유연하게 적용할 수 있습니다.",
      },
      {
        icon: "/asset/icon-1-2-2.png",
        title: "프레임워크 연계",
        description:
          "Redis, Kafka 등 신기술 인터페이스와 Xml·Flat·Json 어댑터를 제공해 내부·외부 연계를 확장하고, Common 기능과 오픈소스·오픈API 활용으로 기술 내재화를 지원합니다.",
      },
      {
        icon: "/asset/icon-1-2-3.png",
        title: "프레임워크 단위 업무 적용",
        description:
          "대량 데이터 출력과 연계 업무를 지원 하며, 전사 시스템에 폭넓게 적용됩니다. 구 프레임워크 전환 표준모델과 개발 방법론을 통해 일관된 개발 환경을 보장합니다.",
      },
    ],
    cases: [
      {
        image: "/asset/img-kb-card.png",
        items: ["u-KESA전환 Pilot"],
      },
      {
        image: "/asset/img-kb-golden.png",
        items: ["시니어플랫폼 구축 사업"],
      },
      {
        image: "/asset/img-kb-card.png",
        items: ["내부 업무시스템 통합 프레임워크 구축"],
      },
    ],
  },
  {
    id: "kbImms",
    title: "KB 통합유지보수 플랫폼 (KB IMMS)",
    subtitle: "Asset",
    description:
      "IT 자산 관리부터 계약, 점검, 장애 관리, SLA 평가까지 전 과정을 통합 지원합니다.",
    bannerImage: "/asset/section-banner-2.png",
    bannerImageMobile: "/asset/section-banner-2-m.png",
    features: [
      {
        icon: "/asset/icon-2-1-1.png",
        title: "전 주기 통합관리",
        description:
          "자산 관리부터 계약, 점검, 장애, SLA, 파트너사까지 모든 유지보수 업무를 하나의 플랫폼에서 통합적으로 관리할 수 있습니다.",
      },
      {
        icon: "/asset/icon-2-1-2.png",
        title: "업무 자동화",
        description:
          "신규·연장 계약 알림, 점검 계획/수행 관리, 보고서 자동 생성 등 업무를 자동화하여 효율성을 높입니다.",
      },
      {
        icon: "/asset/icon-2-1-3.png",
        title: "투명한 이력 관리",
        description:
          "계약 변경, 장애, 점검, 기술 지원 내역을 체계적으로 기록하여 모든 이력을 투명하게 관리하고 신뢰할 수 있는 데이터 기반을 마련합니다.",
      },
      {
        icon: "/asset/icon-2-1-4.png",
        title: "사용자 친화 UI",
        description:
          "대시보드를 통한 종합 현황 파악과 사용성을 고려한 메뉴 구성으로 누구나 빠르게 적응하고 편리하게 활용할 수 있습니다.",
      },
    ],
    functions: [
      {
        icon: "/asset/icon-2-2-1.png",
        title: "대시보드",
        description:
          "유지보수 종합 현황과 점검, SLA, 장애 상태를 한눈에 확인할 수 있는 대시보드를 제공합니다.",
      },
      {
        icon: "/asset/icon-2-2-2.png",
        title: "계약관리",
        description:
          "신규·연장 계약 알림부터 계약 정보 조회·변경 이력 관리까지 지원하며, 유지보수 대상 자산 등록과 라이프사이클 관리도 함께 제공합니다.",
      },
      {
        icon: "/asset/icon-2-2-3.png",
        title: "점검관리",
        description:
          "연간 점검 계획을 수립하고 수행 현황을 관리할 수 있으며, 점검 결과 등록·결재와 보고서 생성을 통해 체계적인 점검 프로세스를 지원합니다.",
      },
      {
        icon: "/asset/icon-2-2-4.png",
        title: "장애관리",
        description:
          "장애 등록과 유형별 분류, 이력 관리를 지원하며, 장애 보고서 작성과 기술지원 관리로 신속하고 정확한 장애 대응이 가능합니다.",
      },
      {
        icon: "/asset/icon-2-2-5.png",
        title: "SLA 관리",
        description:
          "SLA 기준 설정, 평가, 보고서 관리를 비롯해 서비스 요청(SR) 등록·처리·현황 관리와 만족도 조사까지 통합적으로 지원합니다.",
      },
      {
        icon: "/asset/icon-2-2-6.png",
        title: "파트너사 관리",
        description:
          "점검을 수행하는 파트너사를 등록·평가·관리할 수 있으며, 작업 등록과 종류 관리 기능도 함께 제공합니다.",
      },
      {
        icon: "/asset/icon-2-2-7.png",
        title: "고객지원",
        description:
          "공지사항, 자료실(KMS), FAQ를 통해 필요한 정보를 제공하고, 서비스 요청 처리까지 지원해 원활한 고객 지원 환경을 구축합니다.",
      },
      {
        icon: "/asset/icon-2-2-8.png",
        title: "자산관리 & ADMIN",
        description:
          "자산 등록과 이력·주기 관리, 논리 서버 관리 기능을 제공하며, 사용자·코드·연동·알림·구매 정보까지 폭넓게 관리할 수 있습니다.",
      },
    ],
    cases: [
      {
        image: "/asset/img-kb-savingsbank.png",
        items: ["통합유지보수 운영"],
      },
      {
        image: "/asset/img-kb-capital.png",
        items: ["통합유지보수 운영"],
      },
    ],
  },
  {
    id: "kbPms",
    title: "KB플랜잇 프로젝트 관리시스템",
    subtitle: "Asset",
    description:
      "프로젝트 일정, 진척도, 테스트, 결함, 산출물, 인력까지 전 과정을 통합 관리해 효율적인 프로젝트 운영을 지원합니다.",
    bannerImage: "/asset/section-banner-3.png",
    bannerImageMobile: "/asset/section-banner-3-m.png",
    features: [
      {
        icon: "/asset/icon-3-1-1.png",
        title: "통합 관리 솔루션",
        description:
          "프로젝트 일정 수립(WBS)부터 테스트와 산출물 관리까지 하나의 솔루션에서 통합적으로 관리할 수 있습니다.",
      },
      {
        icon: "/asset/icon-3-1-2.png",
        title: "단계별 현황 대시보드",
        description:
          "프로젝트 각 단계별 현황을 대시보드로 한눈에 파악하여 관리 시간을 줄이고 효율적인 프로젝트 운영을 지원합니다.",
      },
      {
        icon: "/asset/icon-3-1-3.png",
        title: "체계적인 업무 할당·관리",
        description:
          "각 업무에 담당자, 검토자, 승인자를 지정하고 이력을 체계적으로 관리하여 협업 과정의 효율성과 투명성을 높입니다.",
      },
    ],
    functions: [
      {
        icon: "/asset/icon-3-2-1.png",
        title: "일정·진척 관리",
        description:
          "일정 수립·업무 할당·진행 상황을 확인하고, 대시보드를 통해 진척률과 달성률을 직관적으로 확인할 수 있습니다.",
      },
      {
        icon: "/asset/icon-3-2-2.png",
        title: "요구사항 관리",
        description:
          "요구사항의 발의부터 구현까지 전 과정을 추적하고, 이력 관리를 통해 각 단계의 진행 상황을 한눈에 파악할 수 있습니다.",
      },
      {
        icon: "/asset/icon-3-2-3.png",
        title: "설계 및 산출물 관리",
        description:
          "설계 단계에서 업무 등록과 할당을 지원하고, 프로젝트 전 과정의 산출물 작성과 자료 관리를 체계적으로 수행할 수 있습니다.",
      },
      {
        icon: "/asset/icon-3-2-4.png",
        title: "이슈 관리",
        description:
          "프로젝트 전 과정에서 발생하는 이슈, 리스크, 액션아이템을 등록하고 처리하며, 대시보드를 통해 처리 현황을 직관적으로 확인할 수 있습니다.",
      },
      {
        icon: "/asset/icon-3-2-5.png",
        title: "개발 관리",
        description:
          "세분화된 개발 작업 등록과 담당자 할당, 진척 관리 및 단계별 검토를 지원하며, 개발 진행 현황을 대시보드로 제공합니다.",
      },
      {
        icon: "/asset/icon-3-2-6.png",
        title: "테스트 및 결함 관리",
        description:
          "테스트 전 과정과 결함 관리를 함께 지원하고, 대시보드를 통해 진행 현황과 산출물 자료를 한눈에 파악할 수 있습니다.",
      },
      {
        icon: "/asset/icon-3-2-7.png",
        title: "인력 관리",
        description:
          "프로젝트에 투입된 인력을 회사별로 등록·관리하고, 투입 현황과 역할을 체계적으로 파악합니다.",
      },
    ],
    cases: null,
  },
  {
    id: "liveCare",
    title: "LiveCare 화상상담 시스템",
    subtitle: "Asset",
    description:
      "실시간 화상 상담으로 고객과 매끄럽게 소통하고, 업종과 분야에 맞춘 최적의 커스터마이징을 제공합니다.",
    bannerImage: "/asset/section-banner-4.png",
    bannerImageMobile: "/asset/section-banner-4-m.png",
    features: [
      {
        icon: "/asset/icon-4-1-1.png",
        title: "검증된 전문성",
        description:
          "화상 상담에 필요한 표준 기능을 기반으로, 금융권 시스템과의 연동 경험을 통해 전문성을 쌓아왔습니다. Co-Browsing 전자서식 공유와 상용화 검증까지 더해 안정성과 신뢰성을 함께 제공합니다.",
      },
      {
        icon: "/asset/icon-4-1-2.png",
        title: "효율적인 운영",
        description:
          "빠른 구축과 유연한 구조, 확장성 있는 설계를 기반으로 상담 관리 기능을 제공하여 편리하고 효율적인 운영을 실현합니다.",
      },
    ],
    functions: [
      {
        icon: "/asset/icon-4-2-1.png",
        title: "본인 인증 솔루션",
        description:
          "신분증, 신용카드, 각종 문서와 자료를 활용한 인증을 지원하며, OCR 기반의 자동 인식 기능을 제공합니다.",
      },
      {
        icon: "/asset/icon-4-2-2.png",
        title: "전자서식 솔루션",
        description:
          "양식 호출부터 문서 작성, 진본 확인, 파일 보관까지 지원하며, 실시간 저장과 인증 연계로 안정적인 문서 처리가 가능합니다.",
      },
      {
        icon: "/asset/icon-4-2-3.png",
        title: "화상 상담 기능",
        description:
          "Co-Browsing, 영상 녹화, 판서, 원격 제어, SMS 연동 등 주요 기능을 통해 상담 효율을 높입니다.",
      },
      {
        icon: "/asset/icon-4-2-4.png",
        title: "관리 기능",
        description:
          "사용자·상담 관리와 상담 내역·통계 분석, 운영 관리를 통해 효율적인 상담 환경을 제공합니다.",
      },
    ],
    cases: [
      {
        image: "/asset/img-kb-bank.png",
        items: null,
      },
      {
        image: "/asset/img-kb-health.png",
        items: null,
      },
      {
        image: "/asset/img-kb-savingsbank.png",
        items: null,
      },
    ],
  },
  {
    id: "kbIssueReporter",
    title: "KB이슈리포터",
    subtitle: "Asset",
    description:
      "업무 시스템에서 발생하는 이슈를 PC와 모바일에서 간편히 등록하고 관리합니다. ",
    bannerImage: "/asset/section-banner-5.png",
    bannerImageMobile: "/asset/section-banner-5-m.png",
    features: [
      {
        icon: "/asset/icon-5-1-1.png",
        title: "솔루션 비용 절감",
        description:
          "테스트 수행과 결함 관리 솔루션을 이슈리포터 하나로 통합 지원하여 보다 간편하고 일관성 있게 테스트와 결함을 관리할 수 있습니다.",
      },
      {
        icon: "/asset/icon-5-1-2.png",
        title: "업무 생산성 증가",
        description:
          "테스트 결과 이미지를 자동으로 수집해 보고에 소요되는 시간을 절감하고, 반복 업무를 줄여 생산성을 높입니다.",
      },
      {
        icon: "/asset/icon-5-1-3.png",
        title: "품질 관리의 최적화",
        description:
          "분산된 파일 관리와 실시간 현황 파악의 한계를 해소하고, 모든 정보를 한눈에 확인하며 체계적으로 관리할 수 있습니다.",
      },
    ],
    functions: [
      {
        icon: "/asset/icon-5-2-1.png",
        title: "케이스의 통합 관리",
        description:
          "많은 테스트 케이스를 한 번에 등록하고 중앙에서 손쉽게 관리할 수 있어 테스트 운영이 더욱 효율적입니다.",
      },
      {
        icon: "/asset/icon-5-2-2.png",
        title: "하나로 연결된 테스트 흐름",
        description:
          "테스트 수행 중 발생한 이슈부터 결함 수정까지 하나의 흐름으로 이어져 관리 과정이 매끄럽게 연결됩니다.",
      },
      {
        icon: "/asset/icon-5-2-3.png",
        title: "시스템 연동을 통한 사용성 확장",
        description:
          "Jira, Redmine, ITMS 등 사용 중인 협업 시스템과 연동하여 티켓 생성과 관리가 가능해 활용 범위가 자연스럽게 확장됩니다.",
      },
      {
        icon: "/asset/icon-5-2-4.png",
        title: "한눈에 보는 대시보드",
        description:
          "대시보드를 통해 테스트와 이슈 현황을 한눈에 확인할 수 있어 진행 상황을 직관적으로 파악할 수 있습니다.",
      },
      {
        icon: "/asset/icon-5-2-5.png",
        title: "빠르고 정확한 이미지 관리",
        description:
          "PC와 모바일 어디서나 테스트 결과 이미지를 빠르고 정확하게 수집·관리할 수 있어 보고와 공유가 훨씬 간편해집니다.",
      },
      {
        icon: "/asset/icon-5-2-6.png",
        title: "누구나 쉽게 사용 가능한 UI",
        description:
          "QA 담당자부터 개발자, 비즈니스 협업까지 누구나 쉽게 사용할 수 있어 협업 환경이 더욱 원활해집니다.",
      },
    ],
    cases: [
      {
        image: "/asset/img-kb-bank.png",
        items: [
          "KB모바일브랜치 고도화",
          "가계대출 All-in-one 시스템 구축",
          "New 스타뱅킹 구축",
          "No.1 기업금융 플랫폼 구축",
          "그룹 생성형AI플랫폼 구축",
        ],
      },
      {
        image: "/asset/img-kb-card.png",
        items: ["KB Pay 중심 통합 앱 서비스 연계 및 확대 구축"],
      },
      {
        image: "/asset/img-kb-savingsbank.png",
        items: ["Kiwi Bank Project 3s 구축", "BNP파리바 카디프 생명"],
      },
    ],
  },
  {
    id: "msp",
    title: "통합 MSP 포털",
    subtitle: "Asset",
    description:
      "KB금융그룹의 클라우드 인프라·보안·운영 등을 안정적으로 관리, 최적화할 수 있는 통합 MSP 포털입니다.",
    bannerImage: "/asset/section-banner-6.png",
    bannerImageMobile: "/asset/section-banner-6-m.png",
    features: [
      {
        icon: "/asset/icon-6-1-1.png",
        title: "멀티클라우드의 통합 빌링",
        description:
          "AWS, GCP, Azure, NCP, Private Cloud 등 다양한 CSP의 빌링을 자동화하여 효율적으로 관리할 수 있습니다.",
      },
      {
        icon: "/asset/icon-6-1-2.png",
        title: "이용금액 현황 및 추이 분석",
        description:
          "월별 이용 금액 현황과 추이를 한눈에 파악할 수 있는 대시보드를 제공해 클라우드 사용 현황을 직관적으로 확인할 수 있습니다.",
      },
      {
        icon: "/asset/icon-6-1-3.png",
        title: "편리한 고객 커뮤니케이션",
        description:
          "각 영역의 SLA 보고서를 온라인으로 발행하고 고객 평가를 수집해 빠르고 편리한 커뮤니케이션을 지원합니다.",
      },
    ],
    functions: [
      {
        icon: "/asset/icon-6-2-1.png",
        title: "통합 온라인 빌링",
        description:
          "CSP별·사업별 이용내역서를 조회하고 고객 승인 기능을 지원하며, 월별 이용금액 추이를 확인할 수 있는 대시보드를 함께 제공합니다.",
      },
      {
        icon: "/asset/icon-6-2-2.png",
        title: "온라인 SLA 보고서",
        description:
          "비용, 서비스 연속성, 장애, 보안, 자원, 업무 요청 관리 등 SLA를 통합 구성해 온라인으로 발행하고 고객 승인과 만족도 평가 기능을 지원합니다.",
      },
      {
        icon: "/asset/icon-6-2-3.png",
        title: "자원 최적화 대시보드",
        description:
          "AWS와 연동해 클라우드 자원 현황을 한눈에 보여주며, RI·SP 활용 등 최적화 방안을 제시해 효율적인 자원 운영을 돕습니다.",
      },
      {
        icon: "/asset/icon-6-2-4.png",
        title: "사업 관리",
        description:
          "사업 계약 정보를 비롯해 고객사 담당자와 운영 담당자, 계약서 및 제반 파일까지 체계적으로 관리할 수 있어 운영 전반을 안정적으로 지원합니다.",
      },
    ],
    cases: [
      {
        image: "/asset/img-kb-group.png",
        items: ["그룹 통합MSP사업"],
      },
    ],
  },
];
